<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.91 7.91l-1.4-4.5A2 2 0 0010.6 2H3.71a1 1 0 00-1 .84L2 7.34A1 1 0 003 8.5h1.12L6.35 13l.08.13a2.12 2.12 0 001.66.87 1.81 1.81 0 00.4 0A1.93 1.93 0 0010 11.8v-1.3h2a2 2 0 001.91-2.59zM8 8.5v3.35L5.91 7.6V4h4.69L12 8.5z"/></svg>